import { cn } from '@/app/utils/cn'
import { DropzoneOptions, useDropzone } from 'react-dropzone'

export interface DropzoneProps {
  onDrop: DropzoneOptions['onDrop']
  value: (File | string)[] | null
  dropzoneOptions?: DropzoneOptions
  render: (props: { value: (File | string)[] | null }) => JSX.Element
  className?: string
  style?: React.CSSProperties
}

export const Dropzone = ({
  onDrop,
  value,
  dropzoneOptions,
  render,
  className,
  style,
}: DropzoneProps) => {
  const { getRootProps, getInputProps, isDragAccept } = useDropzone({
    onDrop,
    ...dropzoneOptions,
  })

  return (
    <div
      className={cn(
        'w-full cursor-pointer rounded-md border border-dashed p-6 hover:border-primary',
        {
          'border-primary': isDragAccept,
        },
        className,
      )}
      style={style}
      {...getRootProps()}
    >
      <div className="w-full">
        <input {...getInputProps()} />
        {render({ value })}
      </div>
    </div>
  )
}
